import { useState } from 'react'

import { useBreakpointValue } from '@chakra-ui/react'

import { DefaultValues, Form } from '@redwoodjs/forms'

import { validationErrorOrDefault } from 'src/lib/utils'

import { toast } from '../../../Toaster'
import FormInner from '../FormInner/FormInner'

type WidthFormTagProps<T> = {
  mutation: (data: T) => unknown
  onClose: (data?: T) => unknown
  defaultValues?: DefaultValues<T>
  children: React.ReactNode
  submitLabel?: string
}

function WithFormTag<T>({
  mutation,
  defaultValues,
  children,
  onClose,
  submitLabel,
}: WidthFormTagProps<T>) {
  const modalSize = useBreakpointValue({ sm: 'full', md: 'md' })
  const [isLoading, setIsLoading] = useState(false)
  const submitHandler = async (obj: T) => {
    setIsLoading(true)
    try {
      await mutation(obj)
      onClose(obj)
    } catch (err) {
      toast('error', validationErrorOrDefault(err, 'Update failed'))
    }
    setIsLoading(false)
  }
  if (modalSize === undefined) return null
  return (
    <Form noValidate onSubmit={submitHandler} config={{ defaultValues }}>
      <FormInner
        onClose={onClose}
        isLoading={isLoading}
        submitLabel={submitLabel}
      >
        {children}
      </FormInner>
    </Form>
  )
}

export default WithFormTag
